module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-ExtraBoldItalic.10041a7.eot";